import { gql } from '../../../apollo/__generated__';

export const REMOVE_ROLE = gql(`
  mutation RemoveRole($removeRoleInput: RemoveRoleInput!) {
    removeRole(removeRoleInput: $removeRoleInput) {
      id
      roles {
        name
        givenByUser {
          id
          firstname
          lastname
          email
        }
      }
    }
  }
`);
